import React from "react";
import { RawIntlProvider } from "react-intl";
import Locale from "../Locale";
import Request from "../Request";
const {XtAxios} = Request;
import Util from "../Util";
import { XtAuth } from "./XtAuth";
import Cookie from "../Cookie";

const initialState = {
  lang: Locale.getLangPath() || "en",
  langCode: Locale.getLangCode() || "en",
  theme: "dark",
  currency: "usd",
  loginStatus:0,
  userInfo: null,
  authInfo: null,
  /** 全站灰度标签名列表（首页 bootstrap 后写入） */
  publicUserTags: [],
  publicUserTagsLoaded: false,
  tenant:"",
};

const reducer = (state, action) => {
  const { type, payload = {} } = action;
  if (type) {
    // type todo
    return state;
  }
  if(typeof window != "undefined" && payload.theme)
  {
    const htmlDom = document.querySelector('body');
    htmlDom?.setAttribute('data-theme', payload.theme);
  }
  if(payload.userInfo && payload.userInfo.accountLevel)
  {
    payload.userInfo.userAccountLevel = payload.userInfo.accountLevel;
  }
  if(payload.userInfo && payload.userInfo.mobileCountryCode)
  {
    payload.userInfo.countryCode = payload.userInfo.mobileCountryCode;
  }
  if(payload.userInfo && payload.userInfo.userName)
  {
    var userName = payload.userInfo.userName;
    if (/@/.test(userName))
      userName = userName.replace(/(\w{2}).*(\w{1})@(.*)/, "$1***@$3");
    else if(userName.length > 7)
      userName = "+" + payload.userInfo.countryCode + " " + userName.replace(/(\d{3})\d*(\d{4})/, "$1***$2");
    else
      userName = "+" + payload.userInfo.countryCode + " " + userName.replace(/(\d{2})\d*(\d{2})/, "$1***$2");
    payload.userInfo.secretUserName = userName;
    // Zendesk 授权：登录后向后端要 JWT，传给 Zendesk Messenger，客服端可识别用户身份与历史会话
    if (payload.loginStatus == 1) {
      XtAxios.post(Util.getOrigin("www") + "/uaapi/uaa/authorize/zendesk/token", {
        "user-id": payload.userInfo.userId || "",
      })
        .then((data) => {
          const token = data?.accessToken ?? data?.data?.accessToken ?? "";
          // 新版 Zendesk embeddables 不支持 messenger.loginUser，不再调用以免报错；若需客服端识别用户请用 embeddables 文档中的认证方式
          // if (token && (window.zE || window.$zE)) {
          //   const zE = window.zE || window.$zE;
          //   zE("messenger", "loginUser", function (callback) { callback(token); });
          // }
        })
        .catch(() => {})
        .finally(() => {});
    }
  }
  
  if(payload.lang == null || payload.lang == "undefined")
  {
    delete payload.lang;
    delete payload.langCode;
  }
  else
  {
    payload.langCode = Locale.getLocaleObj(payload.lang).code;
  }
  if(payload.theme == null || payload.theme == "undefined")
    delete payload.theme;
  if(payload.currency == null || payload.currency == "undefined")
    delete payload.currency;

  return { ...state, ...payload };
};

export const XtContext = React.createContext();

export const XtProvider = ({ payload, intlValue, children }) => {
  if(typeof window != "undefined")
  {
    if(payload.theme)
    {
      const htmlDom = document.querySelector('body');
      htmlDom?.setAttribute('data-theme', payload.theme);
    }
    var clientCode = Cookie.get("clientCode");
    if(!clientCode)
      Cookie.set("clientCode",Date.now() + Util.generateNonceStr(19));
  }
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...(payload || {}),
  });

  return (
    <XtContext.Provider value={[state, dispatch]}>
      <RawIntlProvider value={intlValue}>
        <XtAuth></XtAuth>
        {children}
      </RawIntlProvider>
    </XtContext.Provider>
  );
}